export default __webpack_public_path__ + "static/media/logoprospectscrmwhite2.aa66b88a.png";